import React, { useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";

import AppHeader from "../components/AppHeader";
import SecondWBS from "../components/SecondWBS";

import WorkTreePanel from "../components/WorkTreePanel";
import TakeOffPanel from "../components/TakeOffPanel";
import WorkMeasurePanel from "../components/WorkMeasurePanel";
import WorkDetailsPanel from "../components/WorkDetailsPanel";
import WorkGroupDetailsPanel from "../components/WorkGroupDetailsPanel";
import { TreePine } from "lucide-react";

import {
  Panel,
  PanelGroup,
  PanelResizeHandle,
} from "react-resizable-panels";

/* interface TreeNode {
  text: string;
  tag: number;
  color: string;
  children: TreeNode[];
  wbsNo?: number;
  front?: number;
}
 */
interface TreeNode {
  text: string;
  tag: number;
  color: string;
  children: TreeNode[];

  wbsNo?: number;
  notationNo?: number;
  notationHead?: number;

  front?: number;
}
const SecondtabPanel = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();

 /*  const projectName =
    location.state?.projectName || localStorage.getItem("projectName"); */
const [projectName, setProjectName] = useState(
  location.state?.projectName || localStorage.getItem("projectName") || ""
);
  const userName = localStorage.getItem("userName");
  const [selectedNode, setSelectedNode] = useState<TreeNode | null>(null);
  console.log("Selected Node =", selectedNode);

  
 // const selectedWbsId = selectedNode?.wbsNo ?? selectedNode?.tag ?? null;
 const selectedWbsId =
  selectedNode?.tag && selectedNode.tag < 0
    ? null
    : selectedNode?.wbsNo ?? selectedNode?.tag ?? null; 
 
  const [selectedWorkNo, setSelectedWorkNo] =
  useState<number | null>(null);

  const [selectedWorkGroupNo, setSelectedWorkGroupNo] =
  useState<number | null>(null);

  return (
    // <div className="h-screen flex flex-col bg-gray-100 overflow-hidden">
    <div
  className="h-screen flex flex-col bg-gray-100 overflow-hidden"
  style={{
    fontFamily: "'Segoe UI', sans-serif",
    fontSize: "13px",
    fontWeight: 400,
  }}
>
      
      <AppHeader
  title={projectName || id || "Second Panel"}
  userName={userName}
  activeTab="second"
  onBack={() => navigate(-1)}
  onHome={() => navigate("/projects")}
  onDashboard={() =>
    navigate(`/project/${id}`, {
      state: { projectName },
    })
  }
  onSecond={() =>
    navigate(`/project/${id}/second`, {
      state: { projectName },
    })
  }
  onThird={() =>
    navigate(`/project/${id}/third`, {
      state: { projectName },
    })
  }
  onFourth={() =>
  navigate(`/project/${id}/fourth`, {
    state: { projectName },
  })
}
onFifth={() =>
  navigate(`/project/${id}/fifth`, {
    state: { projectName },
  })
}
  /* onLogout={() => {
    localStorage.removeItem("token");
    navigate("/login"); */
    /* onLogout={() => {
  Object.keys(sessionStorage).forEach((key) => {
    if (
      key.startsWith("treeSelection-") ||
      key.startsWith("treeOpenNodes-")
    ) {
      sessionStorage.removeItem(key);
    }
  });

  localStorage.removeItem("token");
  navigate("/login");
}} */
onLogout={() => {
  sessionStorage.clear();

  localStorage.removeItem("token");

  navigate("/login");
}}

  projectId={Number(id)}
  onProjectUpdated={(updatedName) => {
    setProjectName(updatedName);
  }}
/>

      {/* <div className="flex-1 overflow-hidden"> */}
      <div className="flex-1 min-h-0 overflow-hidden">
         
         <div className="h-full min-h-0 flex flex-col overflow-hidden bg-white">
       
          

          {/* Content Row */}
         
          <PanelGroup
  direction="horizontal"
  autoSaveId="second-tab-layout"
  className="flex-1 min-h-0"
>
           
<Panel defaultSize={25} minSize={15}>
  <div className="flex flex-col h-full min-h-0 overflow-hidden bg-white">

    {/* <div className="h-10 px-4 flex items-center">
      <h2 className=" text-indigo-700 flex items-center gap-2">
        🌳 WBS
      </h2>
    </div> */}
<div className="h-10 px-4 flex items-center">
  <h2
    className="flex items-center gap-2"
    style={{
      fontFamily: "Segoe UI",
      fontSize: "13px",
      fontWeight: 400,
      color: "#1f2937",
    }}
  >
   {/*  <TreePine
      size={14}
      color="#ffffff"
      className="bg-indigo-600 rounded p-[1px]"
    /> */}
    Work Breakdown Structure
  </h2>
</div>
    <div className="flex-1 overflow-y-auto p-0">
      <SecondWBS
        projectId={Number(id)}
        onSelect={setSelectedNode}
      />
    </div>

  </div>
</Panel>

{/* <PanelResizeHandle className="w-4 bg-red-500 cursor-col-resize flex-shrink-0" /> */}
 {/* <PanelResizeHandle className="w-2 cursor-col-resize flex-shrink-0">
  <div className="h-full w-px mx-auto bg-gray-400" />
</PanelResizeHandle> */} 
<PanelResizeHandle className="w-px shrink-0 bg-white border-0 cursor-col-resize" />
{/* <PanelResizeHandle className="w-1 cursor-col-resize flex-shrink-0" /> */}

   {/* Panel 2 */}
<Panel defaultSize={25} minSize={10}>
  <div className="h-full overflow-hidden bg-white">
    <div className="h-10 px-4 flex items-center ">
      <h2> Work Groups</h2>
    </div>
    <WorkTreePanel
     wbsId={selectedWbsId}
    notationNo={selectedNode?.notationNo ?? null}
      onWorkSelect={setSelectedWorkNo}
        onWorkGroupSelect={setSelectedWorkGroupNo}
      />
  </div>
</Panel>

{/* <PanelResizeHandle className="w-1 cursor-col-resize flex-shrink-0" /> */}
{selectedNode && (
/*  <PanelResizeHandle className="w-2 cursor-col-resize flex-shrink-0">
  <div className="h-full w-px mx-auto bg-gray-400" />
</PanelResizeHandle>  */
  <PanelResizeHandle className="w-px shrink-0 bg-white border-0 cursor-col-resize" />
)}

{/* Panel 3 */}
<Panel defaultSize={25} minSize={10}>
  <div className="h-full flex flex-col bg-white overflow-hidden">
     <div className="h-10 px-4 flex items-center">
    <h2>TakeOff & Measures</h2>
  </div>

    {/* TakeOff */}
    <div className="flex-1 min-h-0 border-b border-gray-300 overflow-hidden">
      <TakeOffPanel workNo={selectedWorkNo} />
    </div>

    {/* WorkMeasures */}
    <div className="flex-1 min-h-0 overflow-hidden">
      <WorkMeasurePanel workNo={selectedWorkNo} />
    </div>

  </div>
</Panel>


{selectedNode && (
 /* <PanelResizeHandle className="w-2 cursor-col-resize flex-shrink-0">
  <div className="h-full w-px mx-auto bg-gray-400" />
</PanelResizeHandle>  */
  <PanelResizeHandle className="w-px shrink-0 bg-white border-0 cursor-col-resize" />
)}

{/*< Panel defaultSize={25} minSize={10}>
  <div className="h-full overflow-hidden bg-white">

    {selectedWorkNo ? (
      <WorkDetailsPanel
        workNo={selectedWorkNo}
      />
    ) : selectedWorkGroupNo ? (
      <WorkGroupDetailsPanel
        workGroupNo={selectedWorkGroupNo}
      />
    ) : (
      <div className="p-3 text-gray-500">
        Select a Work or Work Group
      </div>
    )}

  </div>
</Panel>  */  }
<Panel defaultSize={25} minSize={10}>
  <div className="h-full flex flex-col bg-white overflow-hidden">

    {/* Title */}
    <div className="h-10 px-4 flex items-center">
      <h2>Property Grid</h2>
    </div>

    {/* Content */}
    <div className="flex-1 min-h-0 overflow-hidden">
      {selectedWorkNo ? (
        <WorkDetailsPanel
          workNo={selectedWorkNo}
        />
      ) : selectedWorkGroupNo ? (
        <WorkGroupDetailsPanel
          workGroupNo={selectedWorkGroupNo}
        />
      ) : (
        <div className="p-3 text-gray-500">
          Select a Work or Work Group
        </div>
      )}
    </div>

  </div>
</Panel>

            </PanelGroup>
          </div>
        </div>
      </div>
    
  
  );
};

export default SecondtabPanel;